// ref: https://gitlab.com/web-apps-dietela/backend/-/merge_requests/270

export const reqUnlockContent = async(axios, contentAndChallengeId) => {
  return axios.post('/v1/clients/content-unlock', { contentAndChallengeId })
}